/*--------------------------------------
             PAGE HERO SLIDER 
 --------------------------------------*/
sliderPageHero = {
    init: function () {
        if ($(".swiper--page-hero").length > 1) {
            var swiper = new Swiper(".swiper--page-hero", {
                slidesPerView: 1,
                effect: "fade",
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });
        }
    }
};

$(document).ready(function () {
    sliderPageHero.init();
});;

